interface CollectionData {
	acl: Array<any>;
	creationDate: string;
	description: string;
	id: number | string;
	items: any;
	mediaType: string;
	mediaTypes: Array<string>;
	modifiedDate: string;
	title: string;
	numHits: number;
	owner: string;
	roleID: string;
	thumbnail: string;
	showOrder?: boolean;
	showOrderFor?: boolean;
	showOrderOnBehalfOf?: boolean;
	hasVideoWorkflow?: boolean;
	hasAudioWorkflow?: boolean;
	hasClips?: boolean;
	canEdit?: boolean;
	canView?: boolean;
	canEnquire?: boolean;
	isPublic: boolean;
	isPrivate: boolean;
	isShared: boolean;
	publicUrl: string;
    collectionMediaTypes:Array<string>;
	isAnonLink: boolean;
	hasRedacted?: boolean;
	accessibilityCreationDate: string;
	accessibilityModifiedDate: string;
	rawCreationDate: string;
	rawModifiedDate: string;
}